var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350 350",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.637 154.959l84.615 84.615a12.145 12.145 0 0014.331 2.112l50.702-27.218a12.136 12.136 0 0111.943.257l73.976 43.898c5.279 3.132 7.403 9.683 4.932 15.3-6.32 14.385-17.827 40.751-22.398 52.41-.961 2.454-2.393 4.703-4.384 6.426-49.302 42.735-147.392-9.336-222.473-84.417C22.788 173.257-29.283 75.167 13.452 25.865c1.727-1.992 3.976-3.423 6.426-4.384 11.655-4.57 38.025-16.077 52.41-22.398 5.618-2.47 12.168-.347 15.3 4.932l43.898 73.976a12.155 12.155 0 01.257 11.942l-27.218 50.695a12.145 12.145 0 002.112 14.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.553 164.7l52.032-52.033 19.971 19.97c3.28 3.28 8.885 1.783 10.083-2.703L347.942 5.65c1.202-4.481-2.898-8.581-7.38-7.383L216.277 31.568c-4.481 1.202-5.983 6.804-2.704 10.083l19.971 19.971-52.032 52.037a6.255 6.255 0 000 8.845l42.195 42.195a6.255 6.255 0 008.846 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.897a1ecbb05168d3fedd8dfa52267640.svg";
export { ForwardRef as ReactComponent };